import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';
import { TX_ERROR_OWNER_MINT_COINS, TX_OWNER_MINT_COINS } from '../../utils/TransactionTypes';

export default class OwnerMintCoins extends Component {
  constructor (props) {
    super(props);

    this.state = {
      toAddress: '',
      coinsToMint: '',
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
    this.handleToAddressChange = this.handleToAddressChange.bind(this);
    this.handleCoinsChange = this.handleCoinsChange.bind(this);
    this.handleMinting = this.handleMinting.bind(this);
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribe && this.storageUnsubscribe();
    this.setState({contractLoaded: true});
  }

  handleToAddressChange (event) {
    this.setState({
      toAddress: event.target.value
    });
  }

  handleCoinsChange (event) {
    this.setState({
      coinsToMint: +event.target.value || ''
    });
  }

  handleMinting (event) {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.toAddress === '') {
      window.notifications.showError('Receiving address is empty.');

      return;
    }

    if (this.state.coinsToMint <= 0) {
      window.notifications.showError('Coins to Mint must be greater than 0.');

      return;
    }

    window.contract
      .methods
      .ownerMintTokens(
        this.state.toAddress,
        this.state.coinsToMint,
      )
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash',
        hash => addTransactionInProgress(hash, TX_OWNER_MINT_COINS, TX_ERROR_OWNER_MINT_COINS))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          toAddress: '',
          coinsToMint: ''
        });

        window.notifications.showSuccess('Coins were successfully minted.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  }

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    return (
      <form onSubmit={this.handleMinting}>
        <div className="c-form-row">
          <label>Receiver</label>
          <input type="text" placeholder="Receiver" name="toAddress" value={this.state.toAddress}
                 onChange={this.handleToAddressChange}/>
        </div>
        <div className="c-form-row">
          <label>Coins</label>
          <input type="number" placeholder="Coins" name="coins" value={this.state.coinsToMint}
                 onChange={this.handleCoinsChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Mint coins"/>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-owner-mint-coins">
        <h2>Mint coins</h2>
        {this.renderForm()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OwnerDashboardPage/OwnerMintCoins.js